export default {"src":"/_next/static/media/Groupflowers.1d8ec15d.svg","height":71,"width":266,"blurWidth":0,"blurHeight":0};